import { AppMenuPoint, AppMenuPoints, Role } from '@agilox/common';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppNavMenuPointsService {
	private translate = inject(TranslateService);

	getAppNavMenuPoints(role?: Role): Array<AppMenuPoint> {
		let apps = AppMenuPoints;

		if (role) {
			apps = AppMenuPoints.filter(
				(menuPoint: AppMenuPoint) =>
					!menuPoint.roles.length ||
					menuPoint.roles.some((menuPointRole: string) => menuPointRole === role)
			);
		}

		return this.translateAppMenuPoints(apps);
	}

	private translateAppMenuPoints(items: AppMenuPoint[]) {
		return items.map((i) => {
			return {
				...i,
				translation: this.translate.instant('apps.' + i.name),
			};
		});
	}
}
